import { updateGeo, updateUndergroundTravel } from 'shared/slices/jsonQuery';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { addUndergroundsToJsonQuery } from 'shared/utils/jsonQuery';
import { IStationData } from 'shared/types/geo';
import { EMetroTravelType, IJsonQueryUnderground } from '../../../../packages/api-models/common/json_query';
import { getTermValue, getRangeValue, getGeoValueByType } from '../../../../packages/JsonQuery';
import { getDefaultTravelTimeForType } from 'shared/utils/underground';

export const appendUndergroundStations =
  (stations: IStationData[]): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);

    const currentUndergrounds = getGeoValueByType<IJsonQueryUnderground>('underground')(jsonQuery);
    const onlyFoot = getTermValue('only_foot')(jsonQuery);
    const footMin = getRangeValue('foot_min')(jsonQuery);

    if (!currentUndergrounds?.length && !onlyFoot && !footMin) {
      dispatch(
        updateUndergroundTravel({
          travelType: EMetroTravelType.MapFoot,
          travelTime: getDefaultTravelTimeForType(EMetroTravelType.MapFoot),
        }),
      );
    }

    const undergrounds: IJsonQueryUnderground[] = stations.map(item => ({
      type: 'underground',
      id: Number(item.id),
    }));

    const newGeo = addUndergroundsToJsonQuery(jsonQuery, undergrounds);

    dispatch(updateGeo(newGeo));
    dispatch(updateSearchMeta());
  };
